import { InspectionDamageAttributes } from '~/shared/api'
import { Damage } from '../Damage'
import { Wrapper } from './styled'

type DamagesProps = {
  damages?: InspectionDamageAttributes[]
}

export function Damages({ damages }: DamagesProps) {
  if (!damages?.length)
    return <div style={{ fontSize: '18px' }}>Повреждений нет</div>

  return (
    <Wrapper>
      {(damages || []).map((damage, index) => (
        <Damage
          isDetailLabelVisible
          key={index}
          detailTitle={damage.detailTitle}
          extentTitle={damage.extentTitle}
          cost={damage.cost}
          photos={damage.photos}
        />
      ))}
    </Wrapper>
  )
}
